// extracted by mini-css-extract-plugin
export default {"label":"AttributeAssigner_label__YQ1lK","container":"AttributeAssigner_container__yvs5S"};